import styled, { css } from "styled-components"
import { fieldStyles } from "../styles"

export const StyledField = styled.input.attrs({
  maxLength: (props) => props.maxlength
})`
  ${fieldStyles};
  ${({ disabled }) =>
    !!disabled &&
    css`
      cursor: not-allowed;
    `}
`
// export const DisabledStyledField = styled.input`
//   ${fieldStyles};
//   background-color: ${({ theme }) => theme.colors.brand};
// `
